import {CohortsClause} from './cohorts-clause';
import {FilterClause} from './filter-clause';
import {FormulaClause} from './formula-clause';
import {GroupClause} from './group-clause';
import {ShowClause} from './show-clause';
import {TimeClause} from './time-clause';

export class Clause {
  static create(sectionType, attrs) {
    switch (sectionType) {
      case ShowClause.TYPE:
        return ShowClause.createShowClause(attrs);
      case GroupClause.TYPE:
        return new GroupClause(attrs);
      case FilterClause.TYPE:
        return new FilterClause(attrs);
      case FormulaClause.TYPE:
        return new FormulaClause(attrs);
      case TimeClause.TYPE:
        return new TimeClause(attrs);
      case CohortsClause.TYPE:
        return new CohortsClause(attrs);
    }
    throw new Error(`Unknown clause type: ${sectionType}`);
  }
}
